/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import ReactDOM from 'react-dom';

import LanguageModal from './LanguageModal';

const languageModalContainer = document.querySelector('[data-language-modal]');
ReactDOM.render(
    <LanguageModal {...languageModalContainer.dataset} />,
    languageModalContainer,
);

